import React, { useMemo } from 'react';

import { Box, useMediaQuery } from '@mui/material';

import useConfig from '../../../../hooks/useConfig';
import DrawerHeader from '../../drawer/header';
import { MenuOrientation } from '../../../../config';
import Message from './message';
import Profile from './profile';
import Localization from './localization';
import Notification from './notification';
import FullScreen from './fullScreen';
import Customization from './customization';
import MobileSection from './mobileSection';
import MegaMenuSection from './megaMenuSection';

const HeaderContent = () => {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery(theme => theme.breakpoints.down('lg'));

  const localization = useMemo(() => <Localization />, []);

  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open />
      )}
      {!downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      {!downLG && megaMenu}
      {!downLG && localization}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Notification />
      <Message />
      {!downLG && <FullScreen />}
      <Customization />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
